/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Fade } from 'react-reveal';
import Slider from 'react-slick';
import { Col, Container, Row } from 'reactstrap';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import Blog from '../components/Blog';
import { blog } from '../portfolio';

function Experience() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 100,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <Container className="section section-lg">
      <Fade bottom duration={1000} distance="40px">
        <Row>
          <Col lg="12">
            <div className="d-flex p-4">
              <div>
                <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                  <i className="ni ni-laptop text-info" />
                </div>
              </div>
              <div className="pl-4">
                <h4 className="display-3 text-info">Blogs</h4>
              </div>
            </div>
            <Slider {...settings}>
              {blog.map((blg) => (
                <Blog key={blg.id} blog={blg} />
              ))}
            </Slider>
          </Col>
        </Row>
      </Fade>
    </Container>
  );
}

export default Experience;
